import {createSlice} from '@reduxjs/toolkit'
import loadInitialStateObject from './initialStateUtil'

const rjscDetailReviewSlice = createSlice({
    name: 'rjscDetailReview',
    initialState : loadInitialStateObject('rjscDetailReview'),
    reducers : {
        setCompanyRjscDetails(state, action) { 
            state.companyRjscDetails = action.payload
        }
    }
})

export const {setCompanyRjscDetails} = rjscDetailReviewSlice.actions

export default rjscDetailReviewSlice.reducer
    